import { render, staticRenderFns } from "./ServiceStatusStrip.vue?vue&type=template&id=23eb929b&scoped=true&"
import script from "./ServiceStatusStrip.vue?vue&type=script&lang=js&"
export * from "./ServiceStatusStrip.vue?vue&type=script&lang=js&"
import style0 from "./ServiceStatusStrip.vue?vue&type=style&index=0&id=23eb929b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eb929b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23eb929b')) {
      api.createRecord('23eb929b', component.options)
    } else {
      api.reload('23eb929b', component.options)
    }
    module.hot.accept("./ServiceStatusStrip.vue?vue&type=template&id=23eb929b&scoped=true&", function () {
      api.rerender('23eb929b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/ServiceStatusStrip.vue"
export default component.exports